import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline/index.js';
import { operators } from '~/components/flows/ConditionalBuilder';

const SingleConditionPreview = ({ schema, condition }) => {
    const itemSchema = schema.find(s => s.key === condition.left);
    const options = itemSchema?.options || [];
    let optionOpts = {};
    if (Array.isArray(options)) {
        options.forEach(o => (optionOpts[o] = o));
    } else {
        optionOpts = options;
    }

    const operator = operators[condition.operator];
    const needsComparison = !operator?.noComparison;
    const hasOptions = needsComparison && Object.keys(optionOpts).length > 0;

    // Find conditions.right that are missing from optionOpts
    const missingOptions = hasOptions && Array.isArray(condition.right) ? condition.right.filter(r => r && !optionOpts[r]).join(', ') : '';
    const hasOneOptionWithAValue = Array.isArray(condition.right) && condition.right.some(r => r && optionOpts[r]);

    return (
        <div className="flex items-start">
            <div className="mr-1">{itemSchema?.label}</div>
            <div className="mr-1">{operator?.name || condition.operator}</div>
            <div>
                {hasOptions && Array.isArray(condition.right) && (
                    <div>
                        {condition.right.map((r, idx) => (
                            <span key={idx}>
                                {optionOpts[r]}
                                {idx < condition.right.length - 1 && ', '}
                            </span>
                        ))}

                        {!!missingOptions && !hasOneOptionWithAValue && (
                            <div className="text-white bg-red-500 px-2 py-1 rounded-lg">
                                Warning: "{missingOptions}" was set as a condition but is no longer available as an option.
                            </div>
                        )}
                    </div>
                )}
                {hasOptions && !Array.isArray(condition.right) && (
                    <div>{optionOpts[condition.right]}</div>
                )}
                {!hasOptions && needsComparison && <div>{condition.right}</div>}
            </div>
        </div>
    );
};

const FlowConditionsPreview = ({ conditional, schema }) => {
    const join = conditional?.andor === 'and' ? 'And' : 'Or';

    const conditions = conditional?.conditions || [];

    return (
        <div className="flex items-start text-rose-500">
            <AdjustmentsHorizontalIcon className="w-4 h-4 mr-2 mt-1" />
            <div>
                {conditions.map((condition, idx) => (
                    <div key={idx} className="flex items-center">
                        <SingleConditionPreview
                            schema={schema}
                            condition={condition}
                        />
                        {idx < conditions.length - 1 && (
                            <span className="ml-2 text-xs px-1 py-0.5 rounded uppercase bg-rose-100 text-rose-500">
                                {join}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FlowConditionsPreview;
